import template from './post-job.html';
import postJobController from './post-job.controller';
import './post-job.styl';

let postJobComponent = {
  restrict: 'E',
  bindings: {
    user: '<'
  },
  template,
  controller: postJobController,
  controllerAs: 'vm'
};

export default postJobComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/post-job/post-job.component.js
 **/